






























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Topic from "../../../store/entities/articles/topic";
import Editor from '@tinymce/tinymce-vue';
import TinymceInit from "../../../lib/TinymceInit";
@Component({
  components: {Editor}
})
export default class CreateTopic extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  topic: Topic = new Topic();

  tinymceInit = TinymceInit;
  
  save() {
    (this.$refs.topicForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "topic/create",
          data: this.topic
        });
        (this.$refs.topicForm as any).resetFields();
        
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.topicForm as any).resetFields();
    
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  editorBlur() {
    (this.$refs.topicForm as any).validateField('topicBody')
  }
  topicRule = {
    title: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Title")),
        trigger: "blur"
      }
    ],
    systemName: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("SystemName")),
        trigger: "blur"
      }
    ],
    topicBody: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("TopicBody")),
        trigger: "blur"
      }
    ]
  };
}
